<section class="card-section me-5 ms-3">
  <div class="cards-container">
    <mat-card class="card-balance" appearance="outlined">
      <mat-card-content>
        <div>
          <div class="d-flex justify-content-between">
            <span class="card-info">Balance</span>
          </div>
          <div class="balance-amount">
            <span class="amount">{{ BalanceFormatterUtil.getFormattedBalance(balance) }}</span>
            <span class="currency">&#1423;</span>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="d-flex flex-direction-column gap-10px">
    <div class="toggle-container">
      <button class="toggle-button" [matMenuTriggerFor]="individualMenu"
              (click)="toggleIndividual(ActivityTabs.ALL_INDIVIDUAL)"
              (menuOpened)="onIndividualMenuOpened()"
              (menuClosed)="onIndividualMenuClosed()"
              [class.active]="activeTab === ActivityTabs.ALL_INDIVIDUAL">
        <img src="assets/svg/person_16.svg" alt="">
        <span class="mx-2">
          @if (selectedUser) {
            {{ selectedUser.name }} {{ selectedUser.surname }}
          } @else {
            All Individuals
          }
        </span>
        @if (!isIndividualMenuOpen) {
          <img src="assets/svg/arrow_drop_down.svg" alt="down svg">
        } @else {
          <img src="assets/svg/arrow_drop_up.svg" alt="up svg">
        }
      </button>
      <mat-menu #individualMenu="matMenu" (closed)="isIndividualMenuOpen = false">
        <div class="searchable-dropdown-container">
          <div class="search-input-container">
            <mat-icon class="search-icon">search</mat-icon>
            <input type="text"
                   class="search-input"
                   [(ngModel)]="individualSearchQuery"
                   (input)="filterIndividuals()"
                   (click)="$event.stopPropagation()"
                   (keydown)="$event.stopPropagation()"
                   placeholder="Search">
          </div>
          <div class="dropdown-list-container">
            <button mat-menu-item
                    [ngClass]="{ 'selected': selectedUserId == 0 }"
                    (click)="selectUser(null)">
              All
            </button>
            @for (user of filteredUsers; track user.id) {
              <button mat-menu-item
                      [ngClass]="{ 'selected': selectedUserId == Number(user.id) }"
                      (click)="selectUser(user)">
                {{ user.name }} {{ user.surname }}
              </button>
            }
          </div>
        </div>
      </mat-menu>
      <button class="toggle-button" [matMenuTriggerFor]="teamsMenu"
              (click)="toggleIndividual(ActivityTabs.ALL_TEAMS)"
              (menuOpened)="onTeamsMenuOpened()"
              (menuClosed)="onTeamsMenuClosed()"
              [class.active]="activeTab === ActivityTabs.ALL_TEAMS">
        <img src="assets/svg/group.svg" alt="">
        <span class="mx-2">
          @if (selectedTeam) {
            {{ selectedTeam.name == SharedConstants.MY_TEAM ? SharedConstants.TEAM + ' ' + selectedTeam.id : selectedTeam.name }}
          } @else {
            All
          }
        </span>
        @if (!isTeamsMenuOpen) {
          <img src="assets/svg/arrow_drop_down.svg" alt="down svg">
        } @else {
          <img src="assets/svg/arrow_drop_up.svg" alt="up svg">
        }
      </button>
      <mat-menu #teamsMenu="matMenu" (closed)="isTeamsMenuOpen = false">
        <div class="searchable-dropdown-container">
          <div class="search-input-container">
            <mat-icon class="search-icon">search</mat-icon>
            <input type="text"
                   class="search-input"
                   [(ngModel)]="teamSearchQuery"
                   (input)="filterTeams()"
                   (click)="$event.stopPropagation()"
                   (keydown)="$event.stopPropagation()"
                   placeholder="Search">
          </div>
          <div class="dropdown-list-container">
            <button mat-menu-item
                    [ngClass]="{ 'selected': selectedTeamId == 0 }"
                    (click)="selectTeamFromDropdown(null)">
              All
            </button>
            @for (team of filteredTeams; track team.id) {
              <button mat-menu-item
                      [ngClass]="{ 'selected': selectedTeamId == team.id }"
                      (click)="selectTeam(team)">
                {{ team.name == SharedConstants.MY_TEAM ? SharedConstants.TEAM + ' ' + team.id : team.name }}
              </button>
            }
          </div>
        </div>
      </mat-menu>
    </div>
  </div>
</section>
<mat-card class="mt-5 custom-card me-5 ms-3">
  <mat-card-content class="mt-4">
    @if (activeTab === ActivityTabs.MY_TEAM && !currentTeam.requestAllowed) {
      <div class="no-data-container">
        <img src="assets/svg/no_data.svg" alt="down svg">
        <h2>Data is Not Available</h2>
        <span>You have chosen not to track team <br> member transactions.</span>
      </div>
    } @else {
      <div class="transaction-toolbar">
        <div class="transaction-tabs">
          <button [class.active]="selectedTab === SharedConstants.ALL" (click)="selectTab(SharedConstants.ALL)">All
            Transactions
          </button>
          <button [class.active]="selectedTab === SharedConstants.INCOMING"
                  (click)="selectTab(SharedConstants.INCOMING);">Incoming
            @if (isNewTransactions) {
              <img class="ms-2" src="assets/svg/dot.svg">
            }
          </button>
          <button [class.active]="selectedTab === SharedConstants.BALANCE_TRANSFER"
                  (click)="selectTab(SharedConstants.BALANCE_TRANSFER)">
            All requests & Withdrawals
            @if (isNewRequests) {
              <img class="ms-2" src="assets/svg/yellow-dot.svg">
            }
          </button>
        </div>

        <div class="search-filter-section">
          @if (selectedTab !== SharedConstants.BALANCE_TRANSFER) {
            <div class="search-bar">
              <mat-icon>search</mat-icon>
              <input type="text" [(ngModel)]="searchQuery" (input)="search()" placeholder="Search transaction"/>
            </div>
          }
          <button [matMenuTriggerFor]="filterMenu" class="filter-button"
                  [ngClass]="{ 'background-change': menuOpen }"
                  (menuOpened)="onMenuOpened()"
                  (menuClosed)="onMenuClosed()">
            <mat-icon class="mx-1">filter_list</mat-icon>
            @if (menuOpen) {
              {{ 'activity.filter' | translate }}
            }
          </button>
          <mat-menu #filterMenu="matMenu">
            <div class="close-button trigger_class_for_activity_menu" (click)="filterMenu.close">
              <img src="assets/svg/closeButton.svg">
            </div>
            <div [formGroup]="filterForm">
              <div class="modal-header">
                <h2>Filter by</h2>
              </div>
              <div class="modal-body">
                <div class="row">
                  @if (filterForm.hasError('amountInvalid')){
                    <mat-error>
                      <small>'To' must be greater than or equal to 'From'.</small>
                    </mat-error>
                  }
                  <mat-form-field class="col-12 col-lg-6 col-md-12 col-sm-12" (click)="$event.stopPropagation()">
                    <input matInput formControlName="amountFrom" type="number"
                           (keypress)="allowOnlyNumbers($event)" placeholder="Amount(from)"/>
                  </mat-form-field>
                  <mat-form-field class="col-12 col-lg-6 col-md-12 col-sm-12" (click)="$event.stopPropagation()">
                    <input matInput formControlName="amountTo" type="number"
                           (keypress)="allowOnlyNumbers($event)" placeholder="Amount(to)"/>
                  </mat-form-field>
                  @if (filterForm.get('dateRange.startDate')?.invalid || filterForm.get('dateRange.endDate')?.invalid) {
                    <mat-error>
                      Invalid date format
                    </mat-error>
                  }
                  <mat-form-field (click)="$event.stopPropagation(); picker.open()">
                    <mat-label>Date</mat-label>
                    <mat-date-range-input formGroupName="dateRange" [rangePicker]="picker">
                      <input matStartDate formControlName="startDate" placeholder="Start date">
                      <input matEndDate formControlName="endDate" placeholder="End date">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker>
                      <mat-date-range-picker-actions>
                        <button mat-button class="button-size-16" (click)="resetDateRange(picker)">{{ 'activity.reset' | translate }}</button>
                        <button mat-button class="button-size-16" matDateRangePickerApply>{{ 'activity.ok' | translate }}</button>
                      </mat-date-range-picker-actions>
                    </mat-date-range-picker>
                  </mat-form-field>
                  @if (selectedTab === SharedConstants.BALANCE_TRANSFER) {
                    <mat-form-field class="col-md-12 new-style" appearance="fill" (click)="$event.stopPropagation()">
                      <mat-select placeholder="Select card" formControlName="status">
                        <mat-option [value]="SharedConstants.REJECTED">
                          {{ 'payment_status.rejected' | translate }}
                        </mat-option>
                        <mat-option [value]="SharedConstants.COMPLETED">
                          {{ 'payment_status.completed' | translate }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  }
                </div>
              </div>
              <div class="modal-actions">
                <button class="cancel-button option-shared" (click)="resetTransactions(); reset()">Reset</button>
                <button class="request-button option-shared btn"  [disabled]="!filterForm.dirty"
                        (click)="resetTransactions(); filter() ">Filter</button>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>
      <p-table class="transaction-table mt-5" [value]="allPaymentTransactions"
               [tableStyle]="{'min-width': '60rem'}"
               [paginator]="false"
               [rowHover]="true"
               [resizableColumns]="true"
               [sortOrder]="-1">
        <ng-template pTemplate="header">
          <tr>
            <th class="bg-light-white" pResizableColumn pSortableColumn="createdTimestamp">Date & Time
              <p-sortIcon field="createdTimestamp"></p-sortIcon>
            </th>
            <th class="bg-light-white" pResizableColumn>Transaction Type</th>
            <th class="bg-light-blue" pResizableColumn pSortableColumn="fromUser.name">From
              <p-sortIcon field="fromUser.name"></p-sortIcon>
            </th>
            <th class="bg-light-white" pResizableColumn>To
            </th>
            <th class="bg-light-white" pResizableColumn pSortableColumn="amount">Amount
              <p-sortIcon field="amount"></p-sortIcon>
            </th>
            @if (selectedTab !== SharedConstants.BALANCE_TRANSFER) {
              <th class="bg-light-white" pResizableColumn pSortableColumn="standardCommission">Commission
                <p-sortIcon field="standardCommission"></p-sortIcon>
              </th>
              <th class="bg-light-white" pResizableColumn pSortableColumn="extraCommission">Extra Commission
                <p-sortIcon field="extraCommission"></p-sortIcon>
              </th>
            }
            <th class="bg-light-white" pResizableColumn pSortableColumn="paymentStatus">Status
              @if (selectedTab != SharedConstants.INCOMING) {
                <p-sortIcon field=""></p-sortIcon>
              }
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              <div class="date-time-container">
                <div class="date-time-header">
                  <span class="table-card-label">Date & Time</span>
                  @if (row.paymentStatus === SharedConstants.PENDING) {
                    <span class="status-icon pending">
                      <img src="assets/svg/clock_loader_60.svg" alt="Pending">
                    </span>
                  } @else if (row.paymentStatus === SharedConstants.REJECTED) {
                    <span class="status-icon failed">
                      <mat-icon>cancel</mat-icon>
                    </span>
                  } @else {
                    <span class="status-icon success">
                      <mat-icon>check_circle</mat-icon>
                    </span>
                  }
                </div>
                <div class="date-time-value">
                  {{ row.createdTimestamp | date: 'dd.MM.yyyy' }}<br>
                  {{ row.createdTimestamp | date: 'HH:mm' }}
                </div>
              </div>
            </td>
            <td>
              <span class="table-card-label">Transaction Type<br></span>
              <span>{{ formatPaymentMethod(row.paymentMethod) }}</span>
              @if (row.paymentMethod === 'FEE') {
                <span class="badge badge-fee ms-1">Fee</span>
              }
            </td>
            <td class="bg-light-blue">
             <span class="cursor-pointer">
               <span class="table-card-label">From<br></span>
               @if (row.fromUser) {
                 {{ row.fromUser.name + " " + row.fromUser.surname }}
               } @else if (row.buyer) {
                 {{ row.buyer }}
               } @else {
                 -
               }
             </span>
            </td>
            <td>
             <span class="cursor-pointer">
               <span class="table-card-label">To<br></span>
               @if (row.toUser) {
                 {{ row.toUser.name + " " + row.toUser.surname }}
               } @else if (row.bankCard) {
                 {{ row.bankCard.cardholderName }} <br>
                 ******** {{ getLastFourDigits(row.bankCard.accountNumber) }}
                 @if (selectedTab === SharedConstants.BALANCE_TRANSFER){
                   <img class="cursor-pointer ms-2" src="assets/svg/copy.svg"  (click)="copyCode(row.bankCard.accountNumber)" alt="Copy code">
                 }
               } @else {
                 -
               }
             </span>
            </td>
            <td>
             <span><span class="table-card-label">Amount (AMD)<br></span>
               {{ row.paymentMethod == SharedConstants.TRANSFER || !row.paymentMethod ? '-' : '+' }}
               {{ BalanceFormatterUtil.getFormattedBalance(calculateAmount(row)) }} {{ currency }}
             </span>
            </td>
            @if (selectedTab !== SharedConstants.BALANCE_TRANSFER) {
              <td>
                <span><span class="table-card-label">Commission<br></span>
                  @if (row.paymentMethod !== SharedConstants.TRANSFER && calculateCommission(row) !== null) {
                    {{ BalanceFormatterUtil.getFormattedBalance(calculateCommission(row)!) }} {{ getCommissionSymbol(row.commissionUnit) }}
                  } @else {
                    -
                  }
                </span>
              </td>
              <td>
                <span><span class="table-card-label">Extra Commission<br></span>
                  @if (row.paymentMethod !== SharedConstants.TRANSFER && row.extraCommission != null) {
                    {{ BalanceFormatterUtil.getFormattedBalance(row.extraCommission) }} {{ currency }}
                  } @else {
                    -
                  }
                </span>
              </td>
            }
            <td class="actions">
              @if (selectedTab === SharedConstants.BALANCE_TRANSFER) {
                <select class="form-control cursor-pointer status" style="appearance:auto"
                        [(ngModel)]="row.paymentStatus"
                        (change)="updateStatus(row)"
                        [ngClass]="{
                            'select-in-delivery': row.paymentStatus === SharedConstants.REJECTED,
                            'select-delivered': row.paymentStatus === SharedConstants.COMPLETED,
                             'select-new': row.paymentStatus === SharedConstants.PENDING}"
                        [attr.readonly]="row.paymentStatus !== SharedConstants.PENDING ? true : null">
                  <option [value]="row.paymentStatus" disabled>{{ getStatusTranslation(row.paymentStatus) }}</option>
                  <option [value]="SharedConstants.COMPLETED">{{ 'payment_status.completed' | translate }}</option>
                  <option [value]="SharedConstants.REJECTED">{{ 'payment_status.rejected' | translate }}</option>
                </select>
              } @else {
                @if (row.paymentStatus == SharedConstants.PENDING) {
                  <span class="status-icon pending"><img src="assets/svg/clock_loader_60.svg"></span>
                } @else if (row.paymentStatus == SharedConstants.REJECTED) {
                  <span class="status-icon failed"><mat-icon class="ms-0">cancel</mat-icon></span>
                } @else {
                  <span class="status-icon success"><mat-icon class="ms-0">check_circle</mat-icon></span>
                }
              }
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="selectedTab === SharedConstants.BALANCE_TRANSFER ? 6 : 8" class="no-data">No data to display.</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
          {{ totalRecords }} total
        </ng-template>
      </p-table>
      <div class="pagination">
        <a (click)="goToPage(currentPage - 1)" [class.disabled]="currentPage === 0">&laquo;</a>
        <a *ngFor="let page of getPageNumbers()"
           (click)="goToPage(page - 1)"
           [class.active]="currentPage === (page - 1)">
          {{ page }}
        </a>
        <a (click)="goToPage(currentPage + 1)" [class.disabled]="currentPage === totalPages - 1">&raquo;</a>
      </div>
    }
  </mat-card-content>
</mat-card>

